import axios from 'axios';
import { toast } from 'react-toastify';

export const CREATE_BOOK_LOADER = 'CREATE_BOOK_LOADER';
export const createBookLoader = bool => ({
  type: 'CREATE_BOOK_LOADER',
  payload: bool,
});

// export const createBookAction = (obj, clearStates, editState, navigate) => {
export const createBookAction = (obj, setStepCount, setBookId) => {
  return async dispatch => {
    dispatch(createBookLoader(true));

    let data = new FormData();
    data.append('bookName', obj.bookName);
    data.append('cover_img', obj.cover_img);
    data.append('cover_img', obj.logo_img);
    data.append('status', obj.status);

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      // url: `/api/v1/admin/books/create${editState ? `?bookId=${editState._id}` : ''}`,
      url: `/api/v1/admin/books/create`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: data,
    };

    axios
      .request(config)
      .then(response => {
        setStepCount(2);
        setBookId(response.data.data._id);
        dispatch(getAllBookAction());
        dispatch(createBookLoader(false));
        toast.success('Book Has Been Added');
      })
      .catch(error => {
        dispatch(createBookLoader(false));
        toast.error('something went wrong');
      });
  };
};

export const GET_ALL_BOOK_LOADER = 'GET_ALL_BOOK_LOADER';
export const getAllBookLoader = bool => ({
  type: 'GET_ALL_BOOK_LOADER',
  payload: bool,
});

export const getAllBookAction = () => {
  return async dispatch => {
    dispatch(getAllBookLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/books/allgetbook`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    axios
      .request(config)
      .then(response => {
        dispatch(getAllBookLoader(false));
        dispatch(createBookData(response.data.data));
        // clearStates()
      })
      .catch(error => {});
  };
};

export const DELETE_BOOK_LOADER = 'DELETE_BOOK_LOADER';
export const deleteBookLoader = bool => ({
  type: 'DELETE_BOOK_LOADER',
  payload: bool,
});

export const deleteBookAction = (id, handleDeleteOk) => {
  return dispatch => {
    let config = {
      method: 'delete',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/books/bookdelete/${id}`,
      headers: {},
    };
    dispatch(deleteBookLoader(true));

    axios
      .request(config)
      .then(response => {
        dispatch(deleteBookLoader(false));
        dispatch(createBookData(response.data.data));
        if (handleDeleteOk) handleDeleteOk();

        toast.success('Book Has Been Deleted');
      })
      .catch(() => {
        toast.error('something went wrong');
      });
  };
};

export const UPDATE_BOOK_STATUS_LOADER = 'UPDATE_BOOK_STATUS_LOADER';
export const updateBookLoader = bool => ({
  type: 'UPDATE_BOOK_STATUS_LOADER',
  payload: bool,
});

export const updateBookStatusAction = (obj, id) => {
  return async dispatch => {
    // delete obj._id
    // delete obj.cover_img
    dispatch(updateBookLoader(true));
    let data = new FormData();
    data.append('bookName', obj.bookName);
    data.append('status', obj.status);

    let config = {
      method: 'patch',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/books/bookupdate/${id}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: data,
    };

    axios
      .request(config)
      .then(response => {
        dispatch(updateBookLoader(false));

        dispatch(createBookData(response.data.data));
        if (obj.status === 'approved') {
          toast.success('Book Has Been Published');
        } else {
          toast.success('Book Has Been Suppressed');
        }
        // clearStates()
      })
      .catch(error => {
        toast.error('something went wrong');
      });
  };
};

export const updateBookAction = (obj, id, clearStates) => {
  return async dispatch => {
    // delete obj._id
    // delete obj.cover_img
    dispatch(createBookLoader(true));
    delete obj.recitation_audio_url;
    let data = new FormData();
    for (let key in obj) {
      if (key === 'logo_img' || key === 'cover_img') {
        data.append('cover_img', obj[key]);
      } else {
        data.append(key, obj[key]);
      }
    }

    let config = {
      method: 'patch',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/books/bookupdate/${id}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: data,
    };

    axios
      .request(config)
      .then(response => {
        dispatch(createBookLoader(false));
        dispatch(createBookData(response.data.data));
        // dispatch(getAllBookAction())
        if (clearStates) {
          clearStates();
        }
        toast.success('Book Has Been Updated');
      })
      .catch(error => {
        toast.error('something went wrong');
      });
  };
};

export const BOOK_DATA = 'BOOK_DATA';
export const createBookData = payload => {
  return {
    type: 'BOOK_DATA',
    payload: payload,
  };
};

export const GET_SINGLE_BOOK_LOADER = 'GET_SINGLE_BOOK_LOADER';
export const getSingleBookLoader = payload => ({
  type: 'GET_SINGLE_BOOK_LOADER',
  payload: payload,
});

export const getSingleBookAction = id => {
  return async dispatch => {
    // delete obj._id
    // delete obj.cover_img
    dispatch(getSingleBookLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/books/getbook/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then(response => {
        dispatch(getSingleBookLoader(false));
        dispatch(getSingleBookData(response.data.data));

        // clearStates()
      })
      .catch(error => {});
  };
};

export const GET_BOOK_VOLUMES_LOADER = 'GET_BOOK_VOLUMES_LOADER';
export const getBookVolumesLoader = payload => ({
  type: 'GET_BOOK_VOLUMES_LOADER',
  payload: payload,
});

export const getBookVolumesAction = id => {
  return async dispatch => {
    // delete obj._id
    // delete obj.cover_img
    dispatch(getBookVolumesLoader(true));

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/books/getvolumes/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then(response => {
        dispatch(getBookVolumesLoader(false));
        dispatch(getBookVolumesData(response.data.data));

        // clearStates()
      })
      .catch(error => {});
  };
};

export const UPDATE_SINGLE_VOLUMES_LOADER = 'UPDATE_SINGLE_VOLUMES_LOADER';
export const updateSingleVolumesLoader = payload => ({
  type: 'UPDATE_SINGLE_VOLUMES_LOADER',
  payload: payload,
});

export const updateSingleVolumesAction = (obj, id, setEditDataLoader) => {
  return async dispatch => {
    delete obj._id;
    delete obj.__v;
    delete obj.pdf_file_url;
    delete obj.createdAt;
    // delete obj.cover_img
    dispatch(updateSingleVolumesLoader(true));
    setEditDataLoader(true);

    let config = {
      method: 'patch',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/books/update/${id}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: obj,
    };

    axios
      .request(config)
      .then(response => {
        setEditDataLoader(false);
        dispatch(updateSingleVolumesLoader(false));
        dispatch(getBookVolumesData(response.data.data));
        toast.success('Volume Has Been Updated');
        // clearStates()
      })
      .catch(error => {
        setEditDataLoader(false);
        dispatch(updateSingleVolumesLoader(false));
        toast.error('something went wrong');
      });
  };
};

export const GET_BOOK_VOLUMES_DATA = 'GET_BOOK_VOLUMES_DATA';
export const getBookVolumesData = payload => ({
  type: 'GET_BOOK_VOLUMES_DATA',
  payload: payload,
});

export const GET_SINGLE_BOOK_DATA = 'GET_SINGLE_BOOK_DATA';
export const getSingleBookData = payload => ({
  type: 'GET_SINGLE_BOOK_DATA',
  payload: payload,
});

export const DELETE_BOOK_VOLUMES_LOADER = 'DELETE_BOOK_VOLUMES_LOADER';
export const deleteBookVolumesLoader = payload => ({
  type: 'DELETE_BOOK_VOLUMES_LOADER',
  payload: payload,
});

export const deleteBookVolumesAction = (id, bookID) => {
  return async dispatch => {
    // delete obj._id
    // delete obj.cover_img
    dispatch(deleteBookVolumesLoader(true));

    let config = {
      method: 'delete',
      maxBodyLength: Infinity,
      url: `/api/v1/admin/books/delete/${id}/${bookID}`,
      headers: {},
    };

    axios
      .request(config)
      .then(response => {
        dispatch(deleteBookVolumesLoader(false));
        dispatch(getBookVolumesData(response.data.data));
        toast.success('Volume Has Been Deleted');

        // clearStates()
      })
      .catch(error => {
        toast.error('something went wrong');
      });
  };
};

export const DELETE_BOOK_VOLUMES_DATA = 'DELETE_BOOK_VOLUMES_DATA';
export const deleteBookVolumesData = payload => ({
  type: 'DELETE_BOOK_VOLUMES_DATA',
  payload: payload,
});

// {
// bookName
// status
// banner

// }

// {
//     bookName
// status
// banner
// volumnename
// profile
// }

// volumes:[
//    File,
//    File
//    File\

// ]

export const CREATE_VOLUME_LOADER = 'CREATE_VOLUME_LOADER';
export const createVolumeLoader = bool => ({
  type: 'CREATE_VOLUME_LOADER',
  payload: bool,
});

export const CREATE_VOLUME_LOADER_NUMBER = 'CREATE_VOLUME_LOADER_NUMBER';
export const createVolumeLoaderNumber = bool => ({
  type: 'CREATE_VOLUME_LOADER_NUMBER',
  payload: bool,
});

// export const createVolumeAction = (obj, clearStates, editState, navigate) => {
let numberOf = 0;
export const createVolumeAction = (volumes, navigate, clearStates, bookId, bookID) => {
  return async dispatch => {
    dispatch(createVolumeLoader(true));
    dispatch(createVolumeLoaderNumber(`${numberOf} / ${volumes.length}`));
    // volumes.map(async (a, i) => {
    let obj;
    if (volumes[numberOf]?._id) {
      obj = {
        volume_name: volumes[numberOf].volume_name,
        pdf_file: volumes[numberOf].pdf_file,
        bookId: bookId ? bookId : bookID,
        all_in_one: volumes[numberOf].all_in_one,
        edited: volumes[numberOf].edited,
        _id: volumes[numberOf]._id,
        volumne_number: volumes[numberOf].volumne_number,
      };
    } else {
      obj = {
        volume_name: volumes[numberOf].volume_name,
        pdf_file: volumes[numberOf].pdf_file,
        bookId: bookId ? bookId : bookID,
        all_in_one: volumes[numberOf].all_in_one,
        volumne_number: volumes[numberOf].volumne_number,
      };
    }
    if (obj.volume_name) {
      // let last = volumes.filter(e => e.volume_name);

      let data = new FormData();
      for (let key in obj) {
        data.append(key, obj[key]);
      }

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        // url: `/api/v1/admin/books/create${editState ? `?bookId=${editState._id}` : ''}`,
        url: `/api/v1/admin/books/create-volume`,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: data,
      };

      await axios
        .request(config)
        .then(response => {
          // if (naviBool) {
          if (numberOf === volumes.length - 1) {
            numberOf = 0;
            clearStates();
            navigate(`/`);
            dispatch(createVolumeLoader(false));
            dispatch(createVolumeLoaderNumber(false));
          } else {
            numberOf = numberOf + 1;
            dispatch(createVolumeAction(volumes, navigate, clearStates, bookId, bookID));
          }
          // }
          // dispatch(createBookData(response.data.data))
        })
        .catch(error => {
          dispatch(createVolumeLoader(false));
          toast.error(`Something went wrong`);
        });
    }
    // });
  };
};

export const GET__ALL_VOLUME_DATA = 'GET__ALL_VOLUME_DATA';
export const getAllVolumeData = bool => ({
  type: 'GET__ALL_VOLUME_DATA',
  payload: bool,
});
